<script lang="ts">
	import MailTemplate from "../../organisms/settings/MailTemplate.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
		<MailTemplate/>
	</div>
</div>